export function datacloudConnectionPurge({
  purgePreviewUrl,
  purgePreviewStatusUrlTemplate,
}) {
  return {
    showSelectiveImportForm: false,
    showRenameConnectionForm: false,
    showEmailDomainsForm: false,
    showMinimumImportDelayForm: false,
    showManageUserBotStatusForm: false,
    showDeleteConnectionModal: false,
    showResyncDataModal: false,
    showApiCredentialsModal: false,
    purge: {
      showModal: false,
      loading: false,
      summary: null,
      error: null,
      previewId: null,
      pollingInterval: null,
      pollCount: 0,
      maxPolls: 150, // 5 minutes at 2-second intervals
    },
    purgePreviewUrl,
    purgePreviewStatusUrlTemplate,

    formatKey(key) {
      return key
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());
    },

    async openPurgeModal() {
      this.purge.showModal = true;
      if (this.purge.summary || this.purge.loading) return;

      this.purge.loading = true;
      this.purge.error = null;

      try {
        // Step 1: Initiate the async preview
        const response = await fetch(this.purgePreviewUrl, {
          method: "POST",
          headers: {
            "X-CSRF-Token": document
              .querySelector('meta[name="csrf-token"]')
              .getAttribute("content"),
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({}),
        });

        const data = await response.json();

        if (!response.ok || !data?.ok) {
          const errorMessage =
            data?.display_message ||
            data?.message ||
            data?.error ||
            "Unable to start purge preview.";
          throw new Error(errorMessage);
        }

        // Step 2: Start polling for status
        this.purge.previewId = data.preview_id;
        this.startPolling();
      } catch (error) {
        this.purge.error = error.message || "Unable to start purge preview.";
        this.purge.loading = false;
      }
    },

    startPolling() {
      this.pollStatus();

      this.purge.pollingInterval = setInterval(() => {
        this.pollStatus();
      }, 2000);
    },

    async pollStatus() {
      try {
        this.purge.pollCount++;

        if (this.purge.pollCount > this.purge.maxPolls) {
          this.stopPolling();
          this.purge.error =
            "Preview is taking longer than expected. Please try again.";
          this.purge.loading = false;
          return;
        }

        const statusUrl = this.purgePreviewStatusUrlTemplate.replace(
          "PREVIEW_ID",
          this.purge.previewId,
        );

        const response = await fetch(statusUrl, {
          headers: { Accept: "application/json" },
        });

        const data = await response.json();

        if (!response.ok || !data?.ok) {
          throw new Error(data?.error || "Failed to check preview status");
        }

        if (data.status === "complete") {
          this.stopPolling();
          this.purge.summary = data.summary || {};
          this.purge.loading = false;
        } else if (data.status === "error") {
          this.stopPolling();
          this.purge.error =
            data.error_message || "Preview failed. Please try again.";
          this.purge.loading = false;
        }
      } catch (error) {
        console.error("Error polling status:", error);
      }
    },

    stopPolling() {
      if (this.purge.pollingInterval) {
        clearInterval(this.purge.pollingInterval);
        this.purge.pollingInterval = null;
      }
    },

    retryPurgePreview() {
      this.purge.summary = null;
      this.purge.error = null;
      this.purge.previewId = null;
      this.purge.pollCount = 0;
      this.openPurgeModal();
    },

    closePurgeModal() {
      this.stopPolling();
      this.purge.showModal = false;
      this.purge.pollCount = 0;
      this.purge.previewId = null;
    },

    confirmPurge() {
      if (this.purge.loading || this.purge.error) return;
      this.$refs.purgeForm.submit();
    },
  };
}
